import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoNumericTextBoxMixin from './KendoNumericTextBoxMixin'

export default {
    name: 'kendo-numerictextbox',
    mixins: [ KendoNumericTextBoxMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        if(this.v3) {
            return h('input',{
                value: this.value
            })
        } else {
            return h('input',{
                props: {
                    value: this.value
                }
            })
        }
       
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoNumericTextBox/index.js